const urlWrap = (url)=> {return "url(" + url + ")";}

export const soundmapHeader = "Assets/Top_soundmapDK_SuneRettetBund.png"; //128 x 291
export const soundmapHeaderURL = urlWrap(soundmapHeader);

export const soundmapHeaderLogoTitle = "Assets/Top_soundmapDK_Sune_OnlyTop.png"; //951 x 289
export const soundmapHeaderLogoTitleURL = urlWrap(soundmapHeaderLogoTitle); 

export const soundmapHeaderHorLines = "Assets/Top_soundmapDK_Sune_OnlyBottom.png"; //1016 x 68
export const soundmapHeaderHorLinesURL = urlWrap(soundmapHeaderHorLines); 

export const verticalGradientWTT = "Assets/verticalGradientWhiteToTransp.png";
export const verticalGradientWTTURL = urlWrap(verticalGradientWTT); 

export const verticalGradientTTW = "Assets/verticalGradientTranspToWhite.png";
export const verticalGradientTTWURL = urlWrap(verticalGradientTTW);

export const logoDKF = "Assets/Logo_DKF_DK_Large.png";
export const logoDKFURL = urlWrap(logoDKF); 

export const soundmapLogo = "Assets/Soundmap_logo_webCropped.png";
export const soundmapLogoURL = urlWrap(soundmapLogo); 

export const freameRect = "Assets/rektangel-2_big.png";
export const freameRectURL = urlWrap(freameRect); 

export const mapImg = "Assets/mapShot.png";
export const mapImgUrl = urlWrap(mapImg); 

export const soundmapNeedle = "Assets/Soundmaplogo-udentekst_tiny.png";
export const soundmapNeedleURL = urlWrap(soundmapNeedle); 

export const soundmapNeedleEmpty = "Assets/Soundmaplogo-udentekst_tiny_Empty.png";
export const soundmapNeedleEmptyURL = urlWrap(soundmapNeedleEmpty); 

export const playIcon = "Assets/Play_icon_small.png";
export const playIconURL = urlWrap(playIcon);

export const stopIcon = "Assets/Stop_icon_small.png";
export const stopIconURL = urlWrap(stopIcon); 

export const pauseIcon = "Assets/Pause_icon_small.png";
export const pauseIconURL = urlWrap(pauseIcon); 

export const appStoreIcon = "//linkmaker.itunes.apple.com/assets/shared/badges/da-dk/appstore-lrg.svg";
export const appStoreIconUrl = urlWrap(appStoreIcon);	

export const googlePlayIcon = "//linkmaker.itunes.apple.com/assets/shared/badges/da-dk/appstore-lrg.svg";
export const googlePlayIconUrl = urlWrap(googlePlayIcon);	


// WEBPACK FOOTER //
// ./js/visualAssets.jsx